import React, { Children, FC, useState } from 'react';
import $i18n from '@alife/panda-i18n';
import cls from 'classnames';
import './index.scss';
import { GridListProps } from '../grid-list/types';
import { CnStatisticGroupProps } from './types';

export default ({
  GridList,
  CnButton,
}: {
  GridList: FC<GridListProps<React.ReactChild>>;
  CnButton: FC<any>;
}) => {
  const CnStatisticGroup = function ({
    layoutConfig = {
      type: 'flex',
      columnGap: 16,
      rowGap: 16,
    },
    divider,
    children,
    visibleButtonText = $i18n.get({ id: 'loadMore', dm: '加载更多', ns: 'CnStatisticCardPro' }),
    visibleItemCount,
    className,
    style,
  }: CnStatisticGroupProps) {
    const [showNum, setShowNum] = useState<number | undefined>(visibleItemCount);
    const childrenItems = Children.toArray(children);
    const childrenLength = childrenItems.length;
    const visibleControl = showNum && showNum < childrenLength;

    const onClick = (e: MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();
      setShowNum(childrenLength);
    };

    let dataSource = childrenItems as React.ReactChild[];
    if (visibleControl) {
      dataSource = childrenItems.slice(0, showNum) as React.ReactChild[];
    }

    return (
      <div className={cls('cn-statistic-group', className)} style={style}>
        <GridList
          dataSource={dataSource}
          layoutConfig={layoutConfig}
          renderItem={(current: React.ReactChild) => current}
          divider={divider}
        />
        {visibleControl ? (
          <div className="cn-statistic-group-button">
            <CnButton text type="primary" onClick={onClick}>
              {visibleButtonText}
            </CnButton>
          </div>
        ) : null}
      </div>
    );
  };
  return CnStatisticGroup;
};
